import React from "react"

// Provider
import ThemeContext, { ThemeProvider } from "./src/context/ThemeContext"

// Components
import ErrorBoundary from "./src/components/ErrorBoundary/ErrorBoundaryContainer"
import Layout from "./src/components/Layout/Layout"
import Loader from "./src/components/Loader/Loader"

export const onClientEntry = () => {
  if (typeof window === "undefined") return

  const cookies = document.cookie.split("; ").reduce((acc, item) => {
    const [key, value] = item.split("=")
    acc[key] = value
    return acc
  }, {})

  if (cookies.storeOverride === "true") {
    // User has overridden detection — don’t auto-detect
    return
  }

  const country = cookies.country
    ? ["US", "CA", "GB"].includes(cookies.country)
      ? cookies.country
      : "worldwide"
    : "US"
  const shipping = ["US", "CA", "GB"].includes(country)

  window.localStorage.setItem("country", country)
  window.localStorage.setItem("shipping", shipping.toString())
}

export const onRouteUpdate = ({ location }) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "pageview",
      page: location.pathname,
    })
  }
}

const Wrapper = ({ element, props }) => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ThemeContext.Consumer>
          {theme => (
            <React.Fragment>
              {theme.pageLoader && <Loader isLoader={theme.pageLoader} />}
              {element && <Layout {...props}>{element}</Layout>}
            </React.Fragment>
          )}
        </ThemeContext.Consumer>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export const wrapPageElement = Wrapper
